var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "parent" }, [
    _c(
      "div",
      {
        staticClass: "scroll",
        staticStyle: {
          height: "calc(100vh - 110px)",
          display: "flex",
          "flex-direction": "row"
        }
      },
      [
        _c("div", { staticClass: "lefttable" }, [
          _c("div", {
            staticStyle: {
              height: "30px",
              padding: "15px",
              "font-size": "16px"
            },
            attrs: { id: "jobInfoText" }
          }),
          _vm._v(" "),
          _c("hr", {
            staticStyle: { "margin-left": "25px", "margin-right": "25px" }
          }),
          _vm._v(" "),
          _c("table", [
            _vm.column_data[12] != "null"
              ? _c("tr", { staticClass: "hideborder" }, [
                  _c(
                    "td",
                    {
                      staticStyle: { padding: "0px", height: "0px" },
                      attrs: { colspan: "2" }
                    },
                    [
                      _c("div", { staticClass: "parentinvoice" }, [
                        _vm._v(
                          "Parent Invoice:(" + _vm._s(_vm.column_data[12]) + ")"
                        )
                      ])
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _vm._m(0),
              _vm._v(" "),
              _c("td", [
                _c("div", [
                  _vm._v(_vm._s(_vm.term) + ", " + _vm._s(_vm.column_data[8]))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.column_data[11] != null
              ? _c("tr", [
                  _c("td", [_c("b", [_vm._v(_vm._s(_vm.column_names[11]))])]),
                  _vm._v(" "),
                  _c("td", [_c("div", [_vm._v(_vm._s(_vm.column_data[11]))])])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_c("b", [_vm._v(_vm._s(_vm.column_names[1]))])]),
              _vm._v(" "),
              _c(
                "td",
                _vm._l(_vm.poNumbers, function(poNumber, index) {
                  return _c("div", { staticStyle: { margin: "0px" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.poNumberSelect,
                          expression: "poNumberSelect"
                        }
                      ],
                      staticStyle: { width: "50px" },
                      attrs: {
                        id: "po-" + poNumber.toString().split("•")[0],
                        type: "radio"
                      },
                      domProps: {
                        value: "po-" + poNumber.toString().split("•")[0],
                        checked: _vm._q(
                          _vm.poNumberSelect,
                          "po-" + poNumber.toString().split("•")[0]
                        )
                      },
                      on: {
                        change: function($event) {
                          _vm.poNumberSelect =
                            "po-" + poNumber.toString().split("•")[0]
                        }
                      }
                    }),
                    _vm._v(_vm._s(poNumber[0]))
                  ])
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_c("b", [_vm._v(_vm._s(_vm.column_names[2]))])]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  [
                    _c("datetime", {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.column_data[2],
                        callback: function($$v) {
                          _vm.$set(_vm.column_data, 2, $$v)
                        },
                        expression: "column_data[2]"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_c("b", [_vm._v(_vm._s(_vm.column_names[3]))])]),
              _vm._v(" "),
              _c("td", [
                _c(
                  "div",
                  [
                    _c("datetime", {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.column_data[3],
                        callback: function($$v) {
                          _vm.$set(_vm.column_data, 3, $$v)
                        },
                        expression: "column_data[3]"
                      }
                    })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _c("td", [_c("b", [_vm._v(_vm._s(_vm.column_names[4]))])]),
              _vm._v(" "),
              _c("td", [
                _c("div", [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.column_data[4],
                        expression: "column_data[4]"
                      }
                    ],
                    staticStyle: { width: "100%", "min-height": "125px" },
                    attrs: { id: "notesTextArea" },
                    domProps: { value: _vm.column_data[4] },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.column_data, 4, $event.target.value)
                      }
                    }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.perms.includes("77")
              ? _c("tr", [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("td", [
                    _c("div", { staticStyle: { display: "inline-block" } }, [
                      _c("div", { staticStyle: { float: "left" } }, [
                        _c("b", [_vm._v(_vm._s(_vm.column_names[10]))]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.column_data[10],
                              expression: "column_data[10]"
                            }
                          ],
                          staticStyle: { width: "30px" },
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.column_data[10])
                              ? _vm._i(_vm.column_data[10], null) > -1
                              : _vm.column_data[10]
                          },
                          on: {
                            click: function($event) {
                              return _vm.updateKey()
                            },
                            change: function($event) {
                              var $$a = _vm.column_data[10],
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.column_data,
                                      10,
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.column_data,
                                      10,
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(_vm.column_data, 10, $$c)
                              }
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", {
                        staticStyle: {
                          float: "left",
                          width: "50px",
                          height: "30px"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { float: "left" } }, [
                        _c(
                          "button",
                          {
                            staticStyle: { height: "30px" },
                            on: {
                              click: function($event) {
                                return _vm.addTimesToDescription()
                              }
                            }
                          },
                          [_vm._v("Add Date To Description")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { float: "left" } }, [
                        _c(
                          "button",
                          {
                            staticStyle: { height: "30px" },
                            on: {
                              click: function($event) {
                                return _vm.removeTimesFromDescription()
                              }
                            }
                          },
                          [_vm._v("Remove Date From Description")]
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("tr", { key: "time_" + _vm.keyTimes }, [
              _vm._m(2),
              _vm._v(" "),
              _c("td", [
                _c("div", [
                  _c(
                    "table",
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _vm._l(_vm.times, function(time, index) {
                        return _c("tr", [
                          _c("td", [
                            _c(
                              "button",
                              {
                                staticStyle: { width: "30px" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeTime(index)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "trash" }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              { staticStyle: { width: "400px" } },
                              [
                                _c("datetime", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.times[index][1],
                                    callback: function($$v) {
                                      _vm.$set(_vm.times[index], 1, $$v)
                                    },
                                    expression: "times[index][1]"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              { staticStyle: { width: "400px" } },
                              [
                                _c("datetime", {
                                  staticStyle: { width: "100%" },
                                  model: {
                                    value: _vm.times[index][2],
                                    callback: function($$v) {
                                      _vm.$set(_vm.times[index], 2, $$v)
                                    },
                                    expression: "times[index][2]"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticStyle: { width: "400px" } }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.times[index][5],
                                    expression: "times[index][5]"
                                  }
                                ],
                                staticStyle: {
                                  width: "100%",
                                  "min-height": "75px"
                                },
                                domProps: { value: _vm.times[index][5] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.times[index],
                                      5,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              { staticStyle: { width: "125px" } },
                              [
                                _c("autocomplete", {
                                  staticStyle: { width: "100%" },
                                  attrs: { type: _vm.autoWorkerTypeID },
                                  model: {
                                    value: _vm.times[index][3],
                                    callback: function($$v) {
                                      _vm.$set(_vm.times[index], 3, $$v)
                                    },
                                    expression: "times[index][3]"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticStyle: { width: "75px" } }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.times[index][4],
                                    expression: "times[index][4]"
                                  }
                                ],
                                staticStyle: { width: "100%" },
                                attrs: { type: "number" },
                                domProps: { value: _vm.times[index][4] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.times[index],
                                      4,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticStyle: { width: "50px" } }, [
                          _c(
                            "button",
                            {
                              staticStyle: { width: "30px" },
                              on: {
                                click: function($event) {
                                  return _vm.addTime()
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "plus" }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("td"),
                        _c("td"),
                        _c("td"),
                        _c("td")
                      ])
                    ],
                    2
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(4),
              _vm._v(" "),
              _c("td", [
                _c("div", [
                  _c(
                    "table",
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _vm._l(_vm.materials, function(material, index) {
                        return _c("tr", [
                          _c("td", [
                            _c(
                              "button",
                              {
                                staticStyle: { width: "30px" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeMaterial(index)
                                  }
                                }
                              },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: "trash" }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "div",
                              [
                                _c("autocomplete", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    type: _vm.autoMaterialID,
                                    index: index
                                  },
                                  on: { full: _vm.setMaterialFull },
                                  model: {
                                    value: _vm.materials[index][1],
                                    callback: function($$v) {
                                      _vm.$set(_vm.materials[index], 1, $$v)
                                    },
                                    expression: "materials[index][1]"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.materials[index][2],
                                    expression: "materials[index][2]"
                                  }
                                ],
                                staticStyle: { width: "100%" },
                                domProps: { value: _vm.materials[index][2] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.materials[index],
                                      2,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.materials[index][4],
                                    expression: "materials[index][4]"
                                  }
                                ],
                                staticStyle: { width: "100%" },
                                domProps: { value: _vm.materials[index][4] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.materials[index],
                                      4,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.materials[index][3],
                                    expression: "materials[index][3]"
                                  }
                                ],
                                staticStyle: { width: "100%" },
                                attrs: { type: "number" },
                                domProps: { value: _vm.materials[index][3] },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.materials[index],
                                      3,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ])
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _c("tr", [
                        _c("td", { staticStyle: { width: "50px" } }, [
                          _c(
                            "button",
                            {
                              staticStyle: { width: "30px" },
                              on: {
                                click: function($event) {
                                  return _vm.addMaterial()
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "plus" }
                              })
                            ],
                            1
                          )
                        ]),
                        _vm._v(" "),
                        _c("td"),
                        _c("td"),
                        _c("td")
                      ])
                    ],
                    2
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("tr", [
              _vm._m(6),
              _vm._v(" "),
              _c("td", [
                _c("div", [
                  _c(
                    "table",
                    [
                      _c(
                        "tr",
                        [
                          _c("td", { staticStyle: { width: "50px" } }, [
                            _c(
                              "button",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.editAdditionalJoborders()
                                  }
                                }
                              },
                              [_vm._v("Edit")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.additionalJobOrderNames, function(
                            name,
                            index
                          ) {
                            return _c("td", [_c("b", [_vm._v(_vm._s(name))])])
                          })
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.additionalJobOrders, function(joborder, i) {
                        return _c(
                          "tr",
                          [
                            _c("td", { staticStyle: { width: "50px" } }),
                            _vm._v(" "),
                            _vm._l(joborder, function(data, j) {
                              return _c("td", [
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      margin: "0px",
                                      padding: "0px"
                                    }
                                  },
                                  [_vm._v(_vm._s(data))]
                                )
                              ])
                            })
                          ],
                          2
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "righttable" },
          [
            _c("div", [
              _c(
                "button",
                {
                  staticStyle: { float: "left", width: "100px" },
                  on: {
                    click: function($event) {
                      return _vm.changePage(-1)
                    }
                  }
                },
                [_vm._v("<")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticStyle: { float: "right", width: "100px" },
                  on: {
                    click: function($event) {
                      return _vm.changePage(1)
                    }
                  }
                },
                [_vm._v(">")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticStyle: {
                    margin: "0 auto 0 auto",
                    width: "100px",
                    "text-align": "center"
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.invDocPage) +
                      " / " +
                      _vm._s(_vm.documents.length)
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm.perms.includes("77") && _vm.invDocPage == 0
              ? _c("layout-10", {
                  key: "preview_" + _vm.keyPreview,
                  staticStyle: { width: "100%" },
                  attrs: {
                    term: _vm.term,
                    column_data: _vm.column_data,
                    minTimeActive: _vm.column_data[10],
                    times: _vm.times,
                    materials: _vm.materials,
                    ponumber: _vm.getPoNumber,
                    idAddrs: _vm.idAddrs,
                    idHourCalc: _vm.idHourCalc,
                    idMaterialRate: _vm.idMaterialRate,
                    showMiscText: true
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.documents, function(documentid, index) {
              return index + 1 == _vm.invDocPage
                ? _c(
                    "div",
                    {
                      staticClass: "scroll",
                      staticStyle: {
                        width: "95%",
                        height: "calc(100vh - 225px)"
                      }
                    },
                    [
                      _c("document", {
                        attrs: {
                          id: index,
                          dir: "doc_" + documentid + ".jpg",
                          doc_id: documentid
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            })
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "nav-bar" }, [
      _c("div", [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.saveTable()
              }
            }
          },
          [_vm._v("Save")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.completePrep()
              }
            }
          },
          [_vm._v("Complete Final Report Prep")]
        ),
        _vm._v(" "),
        _vm.perms.includes("84")
          ? _c(
              "button",
              {
                attrs: { disabled: _vm.column_data[8] != "PrepComplete" },
                on: {
                  click: function($event) {
                    return _vm.completeInvoice()
                  }
                }
              },
              [_vm._v("Create Invoice")]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticStyle: { width: "200px" } }, [
      _c("b", [_vm._v("Invoice Prep")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Settings")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Times")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td"),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("From")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("To")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Description")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Type")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Persons")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Materials")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td"),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Name")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Description")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Rate")])]),
      _vm._v(" "),
      _c("td", [_c("b", [_vm._v("Quantity")])])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Additional WO Numbers")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cf8a2ffa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf8a2ffa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/layout_9.vue
// module id = 768
// module chunks = 0